// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/search-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/menu.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  font-family: 'Raleway', sans-serif;
 
}

.layout_padding {
  padding: 75px 0;
}

.layout_padding2 {
  padding: 45px 0;
}

.layout_padding2-top {
  padding-top: 45px;
}

.layout_padding-top {
  padding-top: 75px;
}

.layout_padding-bottom {
  padding-bottom: 75px;
}

.call_to-btn {
  display: inline-block;
  padding: 15px 45px;
  border-radius: 10px;
  font-size: 15px;
  background-color: #ffffff;
  color: #262627;
  font-weight: 600;
  transition: all 0.3s ease 0s;
}


.hero_section .call_to-btn {
  
}

.fix_header_name{
  max-width: none;
}

.call_to-btn img {
  width: 18px;
  margin-left: 10px;
}

.btn_on-hover {
  transition: all 0.3s ease 0s;
}

.call_to-btn:hover,
.btn_on-hover:hover {
  box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.7);
  transform: translateY(-7px);
}

.main-heading {
  color: #082465;
  font-weight: bold;
  text-align: center;
}

/*header section*/

.header_section {
  padding-top: 10px;
  font-family: 'Poppins', sans-serif;

}

nav.navbar.navbar-expand-lg {

  padding: 10px 0;
}

.custom_nav-container.navbar-expand-lg .navbar-nav .nav-link {
  padding: 10px 20px;
  color: white;
  text-align: center;
}


a,
a:hover,
a:focus {
  text-decoration: none;
}

a:hover,
a:focus {
  color: initial;
}

.btn,
.btn:focus {
  outline: none !important;
  box-shadow: none;
}

.top_container {
  position: relative;
  margin-top: 50px;
}

.container nav{
  background-color: #7CC6FE;
}

.top_container::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  background-position: right bottom;
  background-repeat: no-repeat;
  z-index: -1;
}

.sub_page .top_container::before {
  background-color: #7CC6FE;
  background-image: none;
}

.top_container::after {
  content: "";
  position: absolute;
  width: 75px;
  height: 75px;
  bottom: 20%;
  left: 6%;
  background-color: #7CC6FE;
}


.sub_page .top_container::after {
  display: none;
}


.navbar-brand img {
  width: 25px;
  margin-right: 7px;
}


.custom_nav-container .nav_search-btn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 22px;
  background-repeat: no-repeat;
  background-position-y: 7px;
  width: 35px;
  height: 35px;
  padding: 0;
  border: none;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navbar-brand span {
  font-size: 22px;
  font-weight: 700;
  color: #fefefe;
}

.custom_nav-container {
  z-index: 99999;
  padding: 15px 0;
}

.custom_nav-container .navbar-toggler {
  outline: none;
}

.custom_nav-container .navbar-toggler .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 40px;
}

/*end header section*/

/* hero section */
.hero-container {
  display: flex;
  padding-top: 90px;
  padding-bottom: 80px;
}

.hero_detail-box {
  width: 40%;
}

.hero_img-container {
  width: 68%;
  margin-left: 15%;
  margin-top: 15%;
}

.hero_img-container img {
  width: 100%;
}

.hero-img2{
  margin-top: 100px;
}

.hero_detail-box {
  color: #fefeff;
}

.hero_detail-box h1 {
  font-size: 50px;
  color: #fefeff;
  font-weight: 600;
  width: 70%;
}


.hero_detail-box p {
  margin-top: 20px;
  margin-bottom: 35px;
}


/* end hero section */

/* common style for some sections */
.common_style>section {
  padding: 50px 0;
}

.common_style .row {
  align-items: center;
}

.common_style h3 {
  font-weight: 600;
  color: #151516;
}

.common_style p {
  font-weight: 600;
  color: #4e4f50;
  margin: 30px 0 50px 0;
}

.common_style img {
  width: 100%;
}


/* end common style */

/* about section */
.about_section {
  text-align: right;
}

.about_section a {
  background-color: #6ebca8;
  color: #fefeff;
}

/* end about section */

/* admission section */


.admission_section a {
  background-color: #7CC6FE;
  color: #fefeff;
}

/* end admission section */

/* why section */

.why_section {
  text-align: right;
}

.why_section a {
  background-color: #6ebca8;
  color: #fefeff;
}

/* end why section */

/* determine section */


.determine_section a {
  background-color: #7CC6FE;
  color: #fefeff;
}


/* end determine section */

/* client section */
.client_section h2,
.client_section h5,
.client_section p {
  font-weight: 600;
}

.client_section h2 {
  text-align: center;
}


.client_section h5 {
  font-size: 24px;
  color: #7CC6FE;
}

.client_section .row {
  align-items: center;
  padding: 75px 0;
  margin: 0 15px;
}

.client_section img {
  width: 100%;
}

.client_img-box::before,
.client_img-box::after {
  content: "";
  position: absolute;
  width: 100px;
  height: 30px;
  border-radius: 20px;
  background-color: #7CC6FE;
}

.client_img-box::before {
  top: -15px;
  transform: rotate(139deg);
  left: -15px;
  animation: beforeanimate 1s;
  animation-delay: .1s;
}

.client_img-box::after {
  bottom: -15px;
  transform: rotate(142deg);
  right: -15px;
  animation: afteranimate 1s;
  animation-delay: .1s;
}


@keyframes beforeanimate {
  0% {
    top: 43%;
    transform: rotate(142deg);
    left: 31%;

  }

  100% {
    top: -15px;
    transform: rotate(139deg);
    left: -15px;
  }
}

@keyframes afteranimate {
  0% {
    bottom: 46%;
    transform: rotate(142deg);
    right: 35%;
  }

  100% {
    bottom: -15px;
    transform: rotate(142deg);
    right: -15px;
  }
}

.client_section .carousel-indicators {
  margin: 0;
  justify-content: flex-end;
  padding-right: 15px;
  bottom: 20px;
}

.client_section .carousel-indicators li {
  width: 25px;
  height: 25px;
  background-color: #6bd1bd;
  border-radius: 100%;
  opacity: 1;
}

.client_section .carousel-indicators li.active {
  background-color: #7CC6FE;
}

/* end client section */

/* contact section */

.contact_section {
  padding: 75px 45px;
  font-family: 'Poppins', sans-serif;
}

.contact_section .row {
  align-items: center;
}

.contact_section input {
  border: none;
  outline: none;
  border-bottom: 1px solid #000;
  width: 90%;
  margin: 15px 0;
}



.contact_form-container button {
  border: none;
  background-color: #6bd1bd;
  color: #fff;
  font-size: 15px;
  padding: 15px 45px;
  border-radius: 30px;
  text-transform: uppercase;
  font-weight: bold;
}

.contact_img-box {

  display: flex;
  align-items: center;

}

.contact_img-box img {
  width: 100%;
}

.contact_section h2 {
  font-size: 26px;
  color: #010103;
  font-weight: 600;
  font-family: 'Raleway', sans-serif;
  margin-bottom: 35px;
}


/* end contact section */


/* info section */
.info_section {
  background-color: #363636;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
}

.info_logo-box {
  display: flex;
  justify-content: center;
}

.info_logo-box h2 {
  font-weight: bold;
  padding: 5px 7px;
  border-bottom: 1.5px solid #7CC6FE;
}

.info_section ul {
  padding: 0;
}

.info_section ul li {
  list-style-type: none;
  margin: 3px 0;
}

.info_section ul li a {
  color: #ffffff;
}

.info_section ul li a:hover {
  color: #7CC6FE;
}

.info_section h5 {
  margin-bottom: 12px;
  font-size: 22px;
}



.info_section .form_container input {
  width: 225px;
  height: 40px;
  padding: 10px;
}

.info_section .form_container input::placeholder {
  color: #ccc8c8;
}

.info_section .form_container button {
  background-color: #7CC6FE;
  border: none;
  outline: none;
  color: #fff;
  padding: 8px 30px;
  margin-top: 15px;
  font-size: 15px;
  text-transform: uppercase;
}

.social_container {
  width: 90%;
  margin: 0 auto;
  border-top: 1px solid #898989;
  background-color: #898989;
  padding: 25px 0;
}

.info_section .social-box {
  margin: 0 auto;
  width: 400px;
  display: flex;
  justify-content: center;
}

.info_section .social-box img {
  width: 35px;
  margin-right: 5px;
}

/* end info section */

/* footer section*/

.footer_section {
  background-color: #7CC6FE;
  padding: 20px 15px;
  font-family: 'Poppins', sans-serif;

}

.footer_section p {
  color: #fdfdfe;
  margin: 0;
  text-align: center;
}

.footer_section a {
  color: #fdfdfe;
}



/* end footer section*/`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;;AAEpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;;AAGA;;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAIE,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;EACjB,kCAAkC;;AAEpC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mDAAmC;EACnC,0BAA0B;EAC1B,iCAAiC;EACjC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,iBAAiB;AACnB;;;AAGA;EACE,yDAA6C;EAC7C,qBAAqB;EACrB,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAsC;EACtC,qBAAqB;AACvB;;AAEA,qBAAqB;;AAErB,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;;AAGA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA,qBAAqB;;AAErB,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;;AAGA,qBAAqB;;AAErB,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;;AAEtB,sBAAsB;;;AAGtB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B,gBAAgB;;AAEhB;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB,sBAAsB;;;AAGtB;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA,0BAA0B;;AAE1B,mBAAmB;AACnB;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;AACtB;;;AAGA;EACE;IACE,QAAQ;IACR,yBAAyB;IACzB,SAAS;;EAEX;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;;AAEvB,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,cAAc;AAChB;;;;AAIA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;;AAGA,wBAAwB;;;AAGxB,iBAAiB;AACjB;EACE,yBAAyB;EACzB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;;;AAIA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,qBAAqB;;AAErB,kBAAkB;;AAElB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;;AAEpC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;;AAIA,sBAAsB","sourcesContent":[".body {\n  font-family: 'Raleway', sans-serif;\n \n}\n\n.layout_padding {\n  padding: 75px 0;\n}\n\n.layout_padding2 {\n  padding: 45px 0;\n}\n\n.layout_padding2-top {\n  padding-top: 45px;\n}\n\n.layout_padding-top {\n  padding-top: 75px;\n}\n\n.layout_padding-bottom {\n  padding-bottom: 75px;\n}\n\n.call_to-btn {\n  display: inline-block;\n  padding: 15px 45px;\n  border-radius: 10px;\n  font-size: 15px;\n  background-color: #ffffff;\n  color: #262627;\n  font-weight: 600;\n  transition: all 0.3s ease 0s;\n}\n\n\n.hero_section .call_to-btn {\n  \n}\n\n.fix_header_name{\n  max-width: none;\n}\n\n.call_to-btn img {\n  width: 18px;\n  margin-left: 10px;\n}\n\n.btn_on-hover {\n  transition: all 0.3s ease 0s;\n}\n\n.call_to-btn:hover,\n.btn_on-hover:hover {\n  -webkit-box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.7);\n  -moz-box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.7);\n  box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.7);\n  transform: translateY(-7px);\n}\n\n.main-heading {\n  color: #082465;\n  font-weight: bold;\n  text-align: center;\n}\n\n/*header section*/\n\n.header_section {\n  padding-top: 10px;\n  font-family: 'Poppins', sans-serif;\n\n}\n\nnav.navbar.navbar-expand-lg {\n\n  padding: 10px 0;\n}\n\n.custom_nav-container.navbar-expand-lg .navbar-nav .nav-link {\n  padding: 10px 20px;\n  color: white;\n  text-align: center;\n}\n\n\na,\na:hover,\na:focus {\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: initial;\n}\n\n.btn,\n.btn:focus {\n  outline: none !important;\n  box-shadow: none;\n}\n\n.top_container {\n  position: relative;\n  margin-top: 50px;\n}\n\n.container nav{\n  background-color: #7CC6FE;\n}\n\n.top_container::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: url(images/hero-bg.png);\n  background-size: 100% 100%;\n  background-position: right bottom;\n  background-repeat: no-repeat;\n  z-index: -1;\n}\n\n.sub_page .top_container::before {\n  background-color: #7CC6FE;\n  background-image: none;\n}\n\n.top_container::after {\n  content: \"\";\n  position: absolute;\n  width: 75px;\n  height: 75px;\n  bottom: 20%;\n  left: 6%;\n  background-color: #7CC6FE;\n}\n\n\n.sub_page .top_container::after {\n  display: none;\n}\n\n\n.navbar-brand img {\n  width: 25px;\n  margin-right: 7px;\n}\n\n\n.custom_nav-container .nav_search-btn {\n  background-image: url(images/search-icon.png);\n  background-size: 22px;\n  background-repeat: no-repeat;\n  background-position-y: 7px;\n  width: 35px;\n  height: 35px;\n  padding: 0;\n  border: none;\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n}\n\n.navbar-brand span {\n  font-size: 22px;\n  font-weight: 700;\n  color: #fefefe;\n}\n\n.custom_nav-container {\n  z-index: 99999;\n  padding: 15px 0;\n}\n\n.custom_nav-container .navbar-toggler {\n  outline: none;\n}\n\n.custom_nav-container .navbar-toggler .navbar-toggler-icon {\n  background-image: url(images/menu.png);\n  background-size: 40px;\n}\n\n/*end header section*/\n\n/* hero section */\n.hero-container {\n  display: flex;\n  padding-top: 90px;\n  padding-bottom: 80px;\n}\n\n.hero_detail-box {\n  width: 40%;\n}\n\n.hero_img-container {\n  width: 68%;\n  margin-left: 15%;\n  margin-top: 15%;\n}\n\n.hero_img-container img {\n  width: 100%;\n}\n\n.hero-img2{\n  margin-top: 100px;\n}\n\n.hero_detail-box {\n  color: #fefeff;\n}\n\n.hero_detail-box h1 {\n  font-size: 50px;\n  color: #fefeff;\n  font-weight: 600;\n  width: 70%;\n}\n\n\n.hero_detail-box p {\n  margin-top: 20px;\n  margin-bottom: 35px;\n}\n\n\n/* end hero section */\n\n/* common style for some sections */\n.common_style>section {\n  padding: 50px 0;\n}\n\n.common_style .row {\n  align-items: center;\n}\n\n.common_style h3 {\n  font-weight: 600;\n  color: #151516;\n}\n\n.common_style p {\n  font-weight: 600;\n  color: #4e4f50;\n  margin: 30px 0 50px 0;\n}\n\n.common_style img {\n  width: 100%;\n}\n\n\n/* end common style */\n\n/* about section */\n.about_section {\n  text-align: right;\n}\n\n.about_section a {\n  background-color: #6ebca8;\n  color: #fefeff;\n}\n\n/* end about section */\n\n/* admission section */\n\n\n.admission_section a {\n  background-color: #7CC6FE;\n  color: #fefeff;\n}\n\n/* end admission section */\n\n/* why section */\n\n.why_section {\n  text-align: right;\n}\n\n.why_section a {\n  background-color: #6ebca8;\n  color: #fefeff;\n}\n\n/* end why section */\n\n/* determine section */\n\n\n.determine_section a {\n  background-color: #7CC6FE;\n  color: #fefeff;\n}\n\n\n/* end determine section */\n\n/* client section */\n.client_section h2,\n.client_section h5,\n.client_section p {\n  font-weight: 600;\n}\n\n.client_section h2 {\n  text-align: center;\n}\n\n\n.client_section h5 {\n  font-size: 24px;\n  color: #7CC6FE;\n}\n\n.client_section .row {\n  align-items: center;\n  padding: 75px 0;\n  margin: 0 15px;\n}\n\n.client_section img {\n  width: 100%;\n}\n\n.client_img-box::before,\n.client_img-box::after {\n  content: \"\";\n  position: absolute;\n  width: 100px;\n  height: 30px;\n  border-radius: 20px;\n  background-color: #7CC6FE;\n}\n\n.client_img-box::before {\n  top: -15px;\n  transform: rotate(139deg);\n  left: -15px;\n  animation: beforeanimate 1s;\n  animation-delay: .1s;\n}\n\n.client_img-box::after {\n  bottom: -15px;\n  transform: rotate(142deg);\n  right: -15px;\n  animation: afteranimate 1s;\n  animation-delay: .1s;\n}\n\n\n@keyframes beforeanimate {\n  0% {\n    top: 43%;\n    transform: rotate(142deg);\n    left: 31%;\n\n  }\n\n  100% {\n    top: -15px;\n    transform: rotate(139deg);\n    left: -15px;\n  }\n}\n\n@keyframes afteranimate {\n  0% {\n    bottom: 46%;\n    transform: rotate(142deg);\n    right: 35%;\n  }\n\n  100% {\n    bottom: -15px;\n    transform: rotate(142deg);\n    right: -15px;\n  }\n}\n\n.client_section .carousel-indicators {\n  margin: 0;\n  justify-content: flex-end;\n  padding-right: 15px;\n  bottom: 20px;\n}\n\n.client_section .carousel-indicators li {\n  width: 25px;\n  height: 25px;\n  background-color: #6bd1bd;\n  border-radius: 100%;\n  opacity: 1;\n}\n\n.client_section .carousel-indicators li.active {\n  background-color: #7CC6FE;\n}\n\n/* end client section */\n\n/* contact section */\n\n.contact_section {\n  padding: 75px 45px;\n  font-family: 'Poppins', sans-serif;\n}\n\n.contact_section .row {\n  align-items: center;\n}\n\n.contact_section input {\n  border: none;\n  outline: none;\n  border-bottom: 1px solid #000;\n  width: 90%;\n  margin: 15px 0;\n}\n\n\n\n.contact_form-container button {\n  border: none;\n  background-color: #6bd1bd;\n  color: #fff;\n  font-size: 15px;\n  padding: 15px 45px;\n  border-radius: 30px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.contact_img-box {\n\n  display: flex;\n  align-items: center;\n\n}\n\n.contact_img-box img {\n  width: 100%;\n}\n\n.contact_section h2 {\n  font-size: 26px;\n  color: #010103;\n  font-weight: 600;\n  font-family: 'Raleway', sans-serif;\n  margin-bottom: 35px;\n}\n\n\n/* end contact section */\n\n\n/* info section */\n.info_section {\n  background-color: #363636;\n  color: #ffffff;\n  font-family: 'Poppins', sans-serif;\n}\n\n.info_logo-box {\n  display: flex;\n  justify-content: center;\n}\n\n.info_logo-box h2 {\n  font-weight: bold;\n  padding: 5px 7px;\n  border-bottom: 1.5px solid #7CC6FE;\n}\n\n.info_section ul {\n  padding: 0;\n}\n\n.info_section ul li {\n  list-style-type: none;\n  margin: 3px 0;\n}\n\n.info_section ul li a {\n  color: #ffffff;\n}\n\n.info_section ul li a:hover {\n  color: #7CC6FE;\n}\n\n.info_section h5 {\n  margin-bottom: 12px;\n  font-size: 22px;\n}\n\n\n\n.info_section .form_container input {\n  width: 225px;\n  height: 40px;\n  padding: 10px;\n}\n\n.info_section .form_container input::placeholder {\n  color: #ccc8c8;\n}\n\n.info_section .form_container button {\n  background-color: #7CC6FE;\n  border: none;\n  outline: none;\n  color: #fff;\n  padding: 8px 30px;\n  margin-top: 15px;\n  font-size: 15px;\n  text-transform: uppercase;\n}\n\n.social_container {\n  width: 90%;\n  margin: 0 auto;\n  border-top: 1px solid #898989;\n  background-color: #898989;\n  padding: 25px 0;\n}\n\n.info_section .social-box {\n  margin: 0 auto;\n  width: 400px;\n  display: flex;\n  justify-content: center;\n}\n\n.info_section .social-box img {\n  width: 35px;\n  margin-right: 5px;\n}\n\n/* end info section */\n\n/* footer section*/\n\n.footer_section {\n  background-color: #7CC6FE;\n  padding: 20px 15px;\n  font-family: 'Poppins', sans-serif;\n\n}\n\n.footer_section p {\n  color: #fdfdfe;\n  margin: 0;\n  text-align: center;\n}\n\n.footer_section a {\n  color: #fdfdfe;\n}\n\n\n\n/* end footer section*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
